import React from "react";
import "./IconButton.scss";

export type IconButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "children" | "title"> & {
  /** The accessible name, also shown as the (brand) tooltip */
  label: string;
  /** Tooltip text if not the label; false for none */
  tooltip?: string | false;
  /** A lucide / mynaui icon element */
  icon: React.ReactNode;
  /** ghost = grey square (row actions, close) · danger = red on hover (delete) · tint = orange tint · plain = no fill */
  variant?: "ghost" | "danger" | "tint" | "plain";
  /** sm 28px, md 34px */
  size?: "sm" | "md";
};

/** A square icon-only button: row actions, a dialog's close, toolbar toggles. */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, variant = "ghost", size = "md", className, type = "button", tooltip, ...rest },
  ref
) {
  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      aria-label={label}
      data-tooltip={tooltip === false ? undefined : tooltip ?? label}
      className={["ui-iconbtn", `ui-iconbtn--${variant}`, `ui-iconbtn--${size}`, className].filter(Boolean).join(" ")}
    >
      {icon}
    </button>
  );
});

export default IconButton;
